import { Typography } from "@material-ui/core";
import React from "react";

function CookiesPolicies(props) {
  return (
    <React.Fragment>
      <Typography paragraph variant="h5">
        Cookie Policy
      </Typography>
      <Typography paragraph variant="body1">
        Updated at 2022-02-02
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Definitions and key terms
      </Typography>
      <Typography paragraph variant="body1">
        To help explain things as clearly as possible in this Cookie Policy,
        every time any of these terms are referenced, are strictly defined as:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            <b>Cookie</b>: small amount of data generated by a website and saved
            by your web browser. It is used to identify your browser, provide
            analytics, remember information about you such as your language
            preference or login information.
          </li>
          <li>
            <b>Company</b>: when this policy mentions "Company," "we," "us," or
            "our," it refers to Invifo Technology International, Level 11, One
            Pacific Place, Sudirman Central Business District, Kav 52 - 53,
            Jakarta Selatan 12190, Indonesia that is responsible for your
            information under this Cookie Policy.
          </li>
          <li>
            <b>Device</b>: any internet connected device such as a phone,
            tablet, computer or any other device that can be used to visit
            Invifo and use the services.
          </li>
          <li>
            <b>Personal Data</b>: any information that directly, indirectly, or
            in connection with other information — including a personal
            identification number — allows for the identification or
            identifiability of a natural person.
          </li>
          <li>
            <b>Service</b>: refers to the service provided by Invifo as
            described in the relative terms (if available) and on this platform.
          </li>
          <li>
            <b>Third-party service</b>: refers to advertisers, contest sponsors,
            promotional and marketing partners, and others who provide our
            content or whose products or services we think may interest you.
          </li>
          <li>
            <b>Website</b>: Invifo's site, which can be accessed via this URL:
            https://invifo.com.
          </li>
          <li>
            <b>You</b>: a person or entity that is registered with Invifo to use
            the Services.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Introduction
      </Typography>
      <Typography paragraph variant="body1">
        This Cookie Policy explains how Invifo and its affiliates (collectively
        "Invifo", "we", "us", and "ours"), use cookies and similar technologies
        to recognize you when you visit our platform, including without
        limitation https://invifo.com and any related URLs, mobile or localized
        versions and related domains / sub-domains ("Websites"). It explains
        what these technologies are and why we use them, as well as the choices
        for how to control them.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        What is a cookie?
      </Typography>
      <Typography paragraph variant="body1">
        A cookie is a small text file that is stored on your computer or other
        internet connected device in order to identify your browser, provide
        analytics, remember information about you such as your language
        preference or login information. They're completely safe and can't be
        used to run programs or deliver viruses to your device.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Why do we use cookies?
      </Typography>
      <Typography paragraph variant="body1">
        We use first party and/or third party cookies on our platform for
        various purposes such as:
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>
            To facilitate the operation and functionality of our platform.
          </li>
          <li>
            To improve your experience of our platform and make navigating
            around them quicker and easier.
          </li>
          <li>
            To allow us to make a bespoke user experience for you and for us to
            understand what is useful or of interest to you.
          </li>
          <li>
            To analyze how our platform is used and how best we can customize
            it.
          </li>
          <li>
            To identify future prospects and personalize marketing and sales
            interactions with it.
          </li>
          <li>
            To facilitate the tailoring of online advertising to your interests.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        What type of cookies does Invifo use?
      </Typography>
      <Typography paragraph variant="body1">
        Cookies can either be session cookies or persistent cookies. A session
        cookie expires automatically when you close your browser. A persistent
        cookie will remain until it expires or you delete your cookies.
        Expiration dates are set in the cookies themselves, some may expire
        after a few minutes while others may expire after multiple years.
        Cookies placed by the website you're visiting are called "first party
        cookies".
      </Typography>
      <Typography paragraph variant="body1">
        Strictly Necessary cookies are necessary for our platform to function
        and cannot be switched off in our systems. They are essential in order
        to enable you to navigate around the platform and use its features. If
        you remove or disable these cookies, we cannot guarantee that you will
        be able to use our platform.
      </Typography>
      <Typography paragraph variant="body1">
        We use the following types of cookies in our platform:
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Essential Cookies
      </Typography>
      <Typography paragraph variant="body1">
        We use essential cookies to make our platform work. These cookies are
        strictly necessary to enable core functionality such as security,
        network management, your cookie preferences and accessibility. Without
        them you wouldn't be able to use basic services. You may disable these
        by changing your browser settings, but this may affect how the Websites
        function.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Performance and Functionality Cookies
      </Typography>
      <Typography paragraph variant="body1">
        These cookies are used to enhance the performance and functionality of
        our platform but are non-essential to their use. However, without these
        cookies, certain functionality like videos may become unavailable or you
        would be required to enter your login details every time you visit the
        platform as we would not be able to remember that you had logged in
        previously.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Marketing Cookies
      </Typography>
      <Typography paragraph variant="body1">
        These account-based marketing cookies enable us to identify future
        prospects and personalize sales and marketing interactions with them.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Analytics and Customization Cookies
      </Typography>
      <Typography paragraph variant="body1">
        These cookies collect information that is used to help us understand how
        our platform is being used or how effective our marketing campaigns are,
        or to help us customize our platform for you.
      </Typography>
      <Typography paragraph variant="body1">
        We use cookies served by Google Analytics to collect limited data
        directly from end-user browsers to enable us to better understand your
        use of our platform. Further information on how Google collects and uses
        this data can be found at:
        https://www.google.com/policies/privacy/partners/. You can opt-out of
        all Google supported analytics on our Websites by visiting:
        https://tools.google.com/dlpage/gaoptout.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Social Media Cookies
      </Typography>
      <Typography paragraph variant="body1">
        These cookies are used when you share information using a social media
        sharing button or "like" button on our Site or you link your account or
        engage with our content on or through a social networking website such
        as Facebook, Twitter or Google+. The social network will record that you
        have done this. These cookies may also include certain code that has
        been placed on the platform to help track conversions from ads, optimize
        ads based on collected data, build targeted audiences for future ads,
        and remarket to qualified users who have already taken certain action on
        the platform.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Third Party Cookies
      </Typography>
      <Typography paragraph variant="body1">
        Some cookies that have been set on our platform are not set on a first
        party basis by Invifo. The Websites can be embedded with content from
        third parties to serve advertising. These third party service providers
        may set their own cookies on your web browser. Third party service
        providers control many of the performance and functionality advertising,
        marketing and analytics cookies described above. We do not control the
        use of these third party cookies as cookies can only be accessed by the
        third party that originally set them.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How you can manage cookies?
      </Typography>
      <Typography paragraph variant="body1">
        Most browsers allow you to control cookies through their 'settings'
        preferences. However, if you limit the ability of websites to set
        cookies, you may worsen your overall user experience, since it will no
        longer be personalized to you. It may also stop you from saving
        customized settings like login information.
      </Typography>
      <Typography paragraph variant="body1">
        Browser manufacturers provide help pages relating to cookie management
        in their products. Browser manufacturers provide help pages relating to
        cookie management in their products. Please see below for more
        information.
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>Google Chrome</li>
          <li>Internet Explorer</li>
          <li>Mozilla Firefox</li>
          <li>Safari (Desktop)</li>
          <li>Safari (Mobile)</li>
          <li>Android Browser</li>
          <li>Opera</li>
          <li>Opera Mobile</li>
        </ul>
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Blocking and disabling cookies and similar technologies
      </Typography>
      <Typography paragraph variant="body1">
        Wherever you're located you may also set your browser to block cookies
        and similar technologies, but this action may block our essential
        cookies and prevent our website from functioning properly, and you may
        not be able to fully utilize all of its features and services. You
        should also be aware that you may also lose some saved information (e.g.
        saved login details, site preferences) if you block cookies on your
        browser. Different browsers make different controls available to you.
        Disabling a cookie or category of cookie does not delete the cookie from
        your browser, you will need to do this yourself from within your
        browser, you should visit your browser's help menu for more information.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Changes To Our Cookie Policy
      </Typography>
      <Typography paragraph variant="body1">
        We may change our Service and policies, and we may need to make changes
        to this Cookie Policy so that they accurately reflect our Service and
        policies. Unless otherwise required by law, we will notify you (for
        example, through our Service) before we make changes to this Cookie
        Policy and give you an opportunity to review them before they go into
        effect. Then, if you continue to use the Service, you will be bound by
        the updated Cookie Policy. If you do not want to agree to this or any
        updated Cookie Policy you can delete your account.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Your Consent
      </Typography>
      <Typography paragraph variant="body1">
        By using our platform, registering an account, or making a purchase, you
        hereby consent to our Cookie Policy and agree to its terms.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Contact Us
      </Typography>
      <Typography paragraph variant="body1">
        Don't hesitate to contact us if you have any questions.
      </Typography>
      <Typography paragraph variant="body1">
        <ul>
          <li>Via Email: support@invifo.com</li>
          <li>Via this Link: https://www.invifo.com/contact-us</li>
        </ul>
      </Typography>
    </React.Fragment>
  );
}

export default CookiesPolicies;
